
function SvgComponent(props) {
    return (
        <svg
            width={24}
            height={24}
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M12.105,17.363l-1.202,5.631h-0.032l-0.871,4h4.903l1.202-5.631h3.502c3.352,0,6.155-2.066,6.905-5.578c0.783-3.664-1.575-5.483-3.869-5.747"
                stroke="currentColor"
                strokeWidth="2"
                strokeMiterlimit="10"
            />
            <path
                d="M18.058,6H9.702L6,22.994h4.903l1.202-5.631h3.502c3.352,0,6.155-2.066,6.905-5.578C23.362,7.809,20.51,6,18.058,6z M17.908,11.785c-0.3,1.292-1.551,2.324-2.802,2.324h-2.3l1.05-4.648h2.402C17.458,9.461,18.259,10.495,17.908,11.785z"
                stroke="currentColor"
                strokeWidth="2"
                strokeMiterlimit="10"
            />
        </svg>
    );
}

export default SvgComponent;